import { mailTypes } from '../util.js'

// SETTINGS
export function getCustomisation(state) {
  return state.customisation
}

export function getCustomisationForUi(
  state,
  _getters,
  _rootState,
  rootGetters,
) {
  const customisation = { ...state.customisation }
  const generalTags = rootGetters['shared/getTagsGeneral']

  customisation.contentTags = customisation.contentTags.map((tagId, index) => {
    const tag = generalTags.find((tag) => tag.value === tagId)
    return {
      ...tag,
      btnClass: 'btn-content-tag-' + index,
      bgClass: 'bg-content-tag-' + index,
    }
  })

  const postTypeMap = {
    1: 'News',
    2: 'Jobs',
    3: 'Events',
  }

  customisation.contentPostTypes = customisation.contentPostTypes.map(
    (typeId) => {
      const text = postTypeMap[typeId]
      return {
        value: typeId,
        text: text,
        btnClass: 'btn-content-post-' + text.toLowerCase(),
        bgClass: 'bg-content-post-' + text.toLowerCase(),
      }
    },
  )

  return customisation
}

export function isDarkMode(state) {
  const customisation = state.customisation
  // Force light mode on layout 2 (ui 3)
  if (customisation.layout === 2) {
    return false
  }
  return customisation.theme === 0
}

export function getCurrentLayout1HomeTemplateId(state) {
  return state.currentLayout1HomeTemplateId
}
export function isConnectionsFeatureEnabled(
  _state,
  _getters,
  _rootState,
  rootGetters,
) {
  return rootGetters['shared/isConnectionsFeatureEnabled']
}
export function isConnectionsSignupEnabled(
  _state,
  _getters,
  _rootState,
  rootGetters,
) {
  return rootGetters['shared/isConnectionsSignupEnabled']
}
export function getConnections(state) {
  return state.connections
}
export function getTVMode(state) {
  return state.TVMode
}

// MIGRATIONS/HOOTMAIL
export function getUpdatesRequiredCount(state) {
  return state.updatesRequiredCount
}

// BETA FEATURE ACCESS -- CURRENT FEATURE: CONNECTIONS
export function canAccessBetaFeature(state) {
  return state.betaFeatureAccess
}

// TENANT POSTS
export function getHomePosts(state) {
  return state.homePosts
}

// CLOUD
export function getCurrentCloudPost(state) {
  return state.currentCloudPost
}
export function getSavedCloudposts(state) {
  return state.savedCloudPosts
}
export function getCloudTenantLeaders(state) {
  return state.cloudTenantLeaders
}
export function getFilterCloudBy(state) {
  return state.filterCloudBy
}
export function getFilterCloudByCount(_state, getters) {
  return Object.entries(getters.getFilterCloudBy).reduce(
    (count, [key, value]) => {
      if (
        key === 'category' ||
        key === 'old_events' ||
        key === 'order_events_by_publish_date' ||
        key === 'matchAll'
      ) {
        return count
      }

      if (value !== null && (!Array.isArray(value) || value.length > 0)) {
        return (count = count + 1)
      }

      return count
    },
    0,
  )
}

// MAIL
export function getPlanLimitations(_state, _getters, rootState) {
  const planLimitations = {
    maxFollowers: 1000,
  }

  if (
    rootState.shared.settings.tenant_id === 5 ||
    rootState.shared.settings.tenant_id === 378
  ) {
    // 5 = Westlake specific subscriber limit, 378 = MAGs
    planLimitations.maxFollowers = 7000
  } else if (rootState.shared.settings.isPro) {
    planLimitations.maxFollowers = 6000
  }

  return planLimitations
}

export function getFollowers(state) {
  return state.followers
}

export function getFollowersCount(_state, getters) {
  return getters.getFollowers?.length || 0
}

export function isOverFollowerLimit(_state, getters, rootState) {
  return (newCount = null) => {
    // if (rootState.shared.settings.tenant_id === 5) {
    //   return false
    // } // no limit westlake - keeping code commented as discussions still in the air

    const count = newCount || getters.getFollowersCount
    return count > getters.getPlanLimitations.maxFollowers
  }
}

export function getFollowersCountClasses(_state, getters) {
  return (count) => {
    count = count || getters.getFollowersCount
    const max = getters.getPlanLimitations.maxFollowers
    if (count >= max) {
      return 'text-red-500'
    } else if (count >= max * 0.8) {
      return 'text-yellow-400'
    } else {
      return 'text-green-400'
    }
  }
}

export function getFollowersByListIds(_state, getters) {
  return getters.getFollowers.reduce((acc, { id, lists, ...rest }) => {
    lists.forEach(({ id: listId }) => {
      if (!acc[listId]) {
        acc[listId] = {}
      }
      acc[listId][id] = { id, lists, ...rest }
    })
    return acc
  }, {})
}

export function getFollowersByListId(_state, getters) {
  return (listId) => {
    const followers = getters.getFollowersByListIds
    return followers?.[listId] || []
  }
}

export function getFollowersBounced(state) {
  return state.followersBounced
}

export function getFollowersListless(state) {
  return state.followersListless
}

// @todo move to constants
export function getFollowerStatusOptions() {
  return [
    {
      value: 0,
      key: 'unsubscribed',
      text: 'Unsubscribed',
    },
    {
      value: 1,
      key: 'subscribed',
      text: 'Subscribed',
    },
  ]
}

export function getPublicMailListId(_state, getters) {
  return getters.getMailListsRaw.find((list) => list.name === 'Public')?.id || 1
}

export function getMailListsRaw(state) {
  return state.mailLists
}

export function getMailLists(state, getters) {
  const bounced = getters.getFollowersBounced
  const listless = getters.getFollowersListless

  const lists = getters.getMailListsRaw.map((list) => {
    // we should always have subscriber data by now!
    const subscribers = getters.getFollowersByListId(list.id)
    const mappedList = {
      ...list,
      subscribers: Object.values(subscribers),
      canAddSubscribers: true,
      canRemoveSubscribers: true,
      canDeleteSubscribers: true,
      canExportList: true,
    }

    if (list.id === getters.getPublicMailListId) {
      mappedList.uneditable = true
      mappedList.undeletable = true
    }

    return mappedList
  })

  // add bounced and unsubscribed lists
  lists.push(
    {
      id: -1,
      name: 'Bounced',
      address: null,
      createdAt: null,
      updatedAt: null,
      subscribers: bounced,
      canAddSubscribers: false,
      canRemoveSubscribers: false,
      canDeleteSubscribers: true,
      canExportList: false,
      actions: false,
      uneditable: true,
      undeletable: true,
    },
    {
      id: -2,
      name: 'Unlisted',
      address: null,
      createdAt: null,
      updatedAt: null,
      subscribers: listless,
      canAddSubscribers: false,
      canRemoveSubscribers: false,
      canDeleteSubscribers: true,
      canExportList: false,
      actions: false,
      uneditable: true,
      undeletable: true,
    },
  )

  return lists
}

/**
 * Gets id of latest (newest) created mail list, ignoring
 * Bounced and Unsubscribed
 *
 * @param {object} state
 * @param {array} getters
 */
export function getMailListLatestId(_state, getters) {
  const lists = getters.getMailLists
  // ignore Bounced and Unsubscribed (last two lists)
  return lists[lists.length - 3]?.id || null
}

/**
 * Gets mail lists of specific type mapped to a useful state for
 * input dropdown selector (objects with properties 'value' and 'text')
 *
 * @param {object} state
 * @param {array} getters
 * @param {null|string} type null or 'careerwise': careerwise; otherwise 'hail' or other SMS key
 * @param {boolean} byHailId true: returns list Hail id; false: returns CW list id
 * @returns {function} returning an array of mapped objects according to param 'type'
 */
export function getMailListInputOptions(_state, getters) {
  return ({ type = null, byHailId = false } = {}) => {
    if (type === mailTypes.careerwise) {
      type = null
    }
    const lists = type ? getters.getMailListsHail(type) : getters.getMailLists

    return (
      lists
        ?.filter(
          // filter out CW bounced and unsubscribed
          (list) => !!type || list.canAddSubscribers,
        )
        .map((list) => {
          return {
            value: byHailId ? list.hailListId : list.id,
            text: list.name,
            subscriberCount: list.subscribers.length || 0,
          }
        }) || []
    )
  }
}

/**
 * Gets map of all Hail mail lists (object key:value pairs by list type)
 *
 * @param {object} state
 * @returns {object} map of Hail lists keyed by 'type' ('hail', 'kamar', etc.)
 */
export function getMailListsHailRaw(state) {
  return state.mailListsHail
}

/**
 * Gets Hail mail lists by specific type ('hail', other SMS),
 * or returns a map to all SMS lists if no type specified
 *
 * @param {object} state
 * @param {array} getters
 * @param {null|string} type null: defaults to all SMS lists; otherwise 'hail', or other SMS key
 * @returns {function} returning an array of lists, or a map of all SMS lists
 */
export function getMailListsHail(_state, getters) {
  return (type) => {
    const lists = getters.getMailListsHailRaw

    if (type) {
      // return lists of that type, if they exist
      return lists[type] ? lists[type] : []
    }

    // otherwise omit hail and return map to SMS lists
    const { hail: _, ...SMSMap } = lists

    return SMSMap
  }
}

/**
 * Gets Hail mail lists by specific type ('hail', other SMS),
 * or returns a map to all SMS lists if no type specified
 *
 * @param {object} state
 * @param {array} getters
 * @param {null|string} type null: defaults to all SMS lists; otherwise 'hail', or other SMS key
 * @returns {function} returning an array of lists, or a map of all SMS lists
 */
export function getMailTypesConfig(_state, getters) {
  return (optionsMap) => {
    optionsMap = optionsMap || {}

    const colorMap = {
      default: '#000000',
      kamar: '#04347A',
      pcschool: '#6c54a3',
      edge: '#723e8a',
    }

    const tabs = [
      {
        id: 0,
        text: mailTypes.careerwise,
        img: '/img/logo-cw.png',
        color: '#ff4778',
        ...optionsMap[mailTypes.careerwise],
      },
      {
        id: 1,
        text: mailTypes.hail,
        img: '/img/tenant1/mail/hail-icon.png',
        color: '#a0d468',
        ...optionsMap[mailTypes.hail],
      },
    ]

    const SMSMap = getters.getMailListsHail()
    for (const key in SMSMap) {
      const tab = {
        id: tabs.length,
        text: key,
        color: colorMap[key] || colorMap.default,
        img: `/img/tenant1/mail/${key}-icon.png`,
        ...optionsMap.sms,
      }

      tabs.push(tab)
    }

    return tabs
  }
}

export function getListsBySMSID(_state, getters) {
  return (smsId) => {
    const key = getters
      .getMailTypesConfig({})
      .find((sms) => sms.id === smsId)?.text

    if (key) {
      return getters.getMailListsHail(key)
    }

    return []
  }
}

export function hasHail(_state, getters) {
  // at least one Hail list exists!
  return !!Object.values(getters.getMailListsHailRaw).some(
    (lists) => !!lists.length,
  )
}

export function hasSMS(_state, getters) {
  // at least one SMS has at least one list!
  return Object.values(getters.getMailListsHail()).some(
    (lists) => !!lists.length,
  )
}

export function getMailListsByFollowerEmail(_state, getters) {
  return (email) => {
    const follower = getters.getFollowers?.find(
      (follower) => follower.email === email,
    )
    return follower?.lists || []
  }
}

export function getMailListIdsByFollowerEmail(_state, getters) {
  return (email) => {
    return getters.getMailListsByFollowerEmail(email).map((list) => list.id)
  }
}

export function getMailListsByHailIds(_state, getters) {
  return (listIds) => {
    // All CW lists
    const cwMailLists = getters.getMailLists
    // Object of all Hail lists
    const hailMailLists = getters.getMailListsHailRaw
    // Array of all hail lists
    const mergedHailLists = Object.values(hailMailLists).flat()

    const mailLists = [...cwMailLists, ...mergedHailLists]

    // Preserve the order of the original list array!!!!!! Very important!!!!!
    return listIds
      .map((id) => {
        const list = mailLists.find((list) => list.hailListId === id)
        return list || null
      })
      .filter((list) => !!list)
  }
}

// @todo move to util
export function mapCampaignIdsToMailLists() {
  return (campaignIds, lists) => {
    const updatedLists = lists.map((list, index) => {
      return {
        ...list, // Spread the existing properties of the object
        campaignId: campaignIds[index], // Add the new property "campaignId" with the corresponding string
      }
    })
    return updatedLists
  }
}

export function getNewsletterPosts(state) {
  return state.newsletterPosts
}

export function getNewsletterSelectedPosts(state) {
  return state.newsletterSelectedPosts
}

export function getAutoNewsletterStatus(state) {
  return state.autoNewsletterStatus
}

export function getSchoolsList(state) {
  return state.schoolsList
}
